const toNormal = (time) => {
  return time >= 10 ? time : "0" + time;
};

const timeDiff = (nextTime) => {
  let currentTime = new Date().getTime();
  let time = nextTime - currentTime;

  if (time < 0) {
    return null;
  }

  // ������������
  var days = Math.floor(time / (24 * 3600 * 1000));

  if (days > 0) {
    return `${days} days`;
  }
  //��������Сʱ��
  let leave1 = time % (24 * 3600 * 1000);
  var hours = Math.floor(leave1 / (3600 * 1000));
  if (hours > 0) {
    return `${hours} hrs`;
  }
  //�������ķ�����
  var leave2 = leave1 % (3600 * 1000);
  var minutes = Math.floor(leave2 / (60 * 1000));
  if (minutes > 0) {
    return `${minutes} mins`;
  }
};

const getTime = (time) => {
  if (time < 0) {
    return "";
  }
  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let days = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();

  let strs = `${year}/${toNormal(month)}/${toNormal(days)} ${toNormal(
    hours
  )}:${toNormal(minutes)}`;
  return strs;
};

const _hanlePort = (currentTvwallData) => {
  let layoutXY = [];
  const X = currentTvwallData.tvwallParams.dimensionX;
  const Y = currentTvwallData.tvwallParams.dimensionY;
  const allNum = X * Y;

  currentTvwallData.tvwallParams.layouts.forEach((item) => {
    const coordinate = [];
    //����ÿһ�����ӵ�����
    for (var i = 0; i < allNum; i++) {
      coordinate.push({
        x: (i % X) + 1,
        y: parseInt(i / X) + 1,
      });
    }
    item.grouping.forEach((item2) => {
      if (item2.groupingType === 2) {
        //����members��X����
        //����members��Y����
        const layoutArrX = [];
        const layoutArrY = [];
        item2.members.forEach((item3) => {
          layoutArrX.push(coordinate[item3 - 1].x);
          layoutArrY.push(coordinate[item3 - 1].y);
        });
        //ȡX��������ֵ����Сֵ
        var xMax = Math.max.apply(Math, layoutArrX);
        var xMin = Math.min.apply(Math, layoutArrX);
        //ȡY��������ֵ����Сֵ
        var yMax = Math.max.apply(Math, layoutArrY);
        var yMin = Math.min.apply(Math, layoutArrY);
        //�Ŵ���
        const enlargeX = xMax - xMin + 1;
        const enlargeY = yMax - yMin + 1;
        item2.members.forEach((item3) => {
          //background-image positon ƫ����
          coordinate[item3 - 1].moveX = -(coordinate[item3 - 1].x - xMin);
          coordinate[item3 - 1].moveY = -(coordinate[item3 - 1].y - yMin);
          coordinate[item3 - 1].enlargeX = enlargeX;
          coordinate[item3 - 1].enlargeY = enlargeY;
          // coordinate[item3-1].img = item2.imgs
        });
      } else if (item2.groupingType === 1 || item2.groupingType === 3) {
        if (item2.members !== undefined) {
          item2.members.forEach((item3) => {
            coordinate[item3 - 1].moveX = 0;
            coordinate[item3 - 1].moveY = 0;
            coordinate[item3 - 1].enlargeX = 1;
            coordinate[item3 - 1].enlargeY = 1;
            // coordinate[item3-1].img = item2.imgs[index3]
          });
        }
      }
    });
    layoutXY.push(coordinate);
  });
  return { layoutXY };
};

const calcCoordinate = (currentTvwallData) => {
  const X = currentTvwallData.tvwallParams.dimensionX;
  const Y = currentTvwallData.tvwallParams.dimensionY;
  const allNum = X * Y;
  const coordinate = [];
  //����ÿһ�����ӵ�����
  for (var i = 0; i < allNum; i++) {
    coordinate.push({
      x: (i % X) + 1,
      y: parseInt(i / X) + 1,
    });
  }
  return coordinate;
};

const deepClone = (obj) => {
  var newObj;
  if (Object.prototype.toString.call(obj) === "[object Date]") {
    newObj = new Date(obj.valueOf());
  } else if (Object.prototype.toString.call(obj) === "[object RegExp]") {
    var pattern = obj.valueOf();
    var flags = "";
    flags += pattern.global ? "g" : "";
    flags += pattern.ignoreCase ? "i" : "";
    flags += pattern.multiline ? "m" : "";
    newObj = new RegExp(pattern.source, flags);
  } else {
    newObj = obj instanceof Array ? [] : {};
    for (var i in obj) {
      newObj[i] = typeof obj[i] == "object" ? deepClone(obj[i]) : obj[i];
    }
  }
  return newObj;
};

const deepCloneByJSON = (data) => {
  return JSON.parse(JSON.stringify(data));
};

let timer = null;
function debounce(func, wait, imme) {
  let context = this;
  let args = arguments;
  if (timer) {
    clearTimeout(timer);
  }
  if (imme) {
    let doNow = !timer;
    timer = setTimeout(() => {
      timer = null;
    }, wait);
    if (doNow) {
      func.apply(context, args);
    }
  } else {
    timer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  }
}

const id2mac = (id) => {
  let len = id.length;
  let data = id.split("").splice(0, len - 4);
  let mac = [];
  data.forEach((item, index) => {
    if (index % 2 === 0) {
      mac.push(`${item}${data[index + 1]}`);
    }
  });
  return mac.join("-");
};

const Hex2Decimal = (hex) => {
  let num = hex.toString(2).padStart(4, "0");
  let arr = num
    .split("")
    .reverse()
    .map((item) => Number(item));
  return arr;
};

const handleRxData = (rx, rgroups, vws) => {
  let rxObj = {},
    rxids = [];
  rx.forEach((item) => {
    rxObj[item.id] = item;
    rxids.push(item.id);
  });

  let unSelectRx = [];

  rgroups.forEach((item) => {
    item.memberIds.forEach((id) => {
      if (rxids.includes(id)) {
        rxids.splice(
          rxids.findIndex((thisId) => thisId === id),
          1
        );
      }
    });
  });

  vws.forEach((item) => {
    item.items[0].rxids.forEach((id) => {
      if (id.includes(":")) {
        let curRID = id.split(":")[0];
        if (rxids.includes(curRID)) {
          rxids.splice(
            rxids.findIndex((thisId) => thisId === curRID),
            1
          );
        }
      } else {
        if (rxids.includes(id)) {
          rxids.splice(
            rxids.findIndex((thisId) => thisId === id),
            1
          );
        }
      }
    });
  });

  rxids.forEach((item) => {
    unSelectRx.push(rxObj[item]);
  });

  return {
    unSelectRx,
    rxObj,
  };
};

const judgeConnMode = (defaultConnMode) => {
  let accessVal = 0,
    loginVal = 0,
    lockVal = 0;
  if (defaultConnMode < 16) {
    accessVal = defaultConnMode;
    loginVal = 0;
    lockVal = 0;
  } else if (defaultConnMode > 16 && defaultConnMode < 25) {
    accessVal = defaultConnMode - 16;
    loginVal = 16;
    lockVal = 0;
  } else if (defaultConnMode > 24 && defaultConnMode < 41) {
    accessVal = defaultConnMode - 32;
    loginVal = 0;
    lockVal = 32;
  } else {
    accessVal = defaultConnMode - 48;
    loginVal = 16;
    lockVal = 32;
  }

  return { accessVal, loginVal, lockVal };
};

const getBrowserLanguage = () => {
  var lang = navigator.language || navigator.userLanguage; //常规浏览器语言和IE浏览器
  if (lang === "zh-TW") {
    lang = "tw";
  } else if (lang === "zh-CN") {
    lang = "cn";
  }
  return lang;
};

export {
  getTime,
  timeDiff,
  _hanlePort,
  calcCoordinate,
  deepClone,
  debounce,
  id2mac,
  Hex2Decimal,
  handleRxData,
  judgeConnMode,
  deepCloneByJSON,
  getBrowserLanguage,
};
